import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { ReactElement } from 'react';

interface LightBoxState {
  mobile: boolean;
  visible: boolean;
  content?: ReactElement;
  secondVisible?: boolean;
  secondContent?: ReactElement;
  isLoading?: boolean;
  onClose?(): void;
  onSecondClose?(): void;
  noDismiss?: boolean;
  overlayVisible?: boolean;
  allowBackgroundInteraction?: boolean;
  contentVerticalAlign?: 'center' | 'top' | 'bottom';
  contentHorizontalAlign?: 'center' | 'left';
  contentTopOffset?: number;
  contentBottomOffset?: number;
  contentLeftOffset?: number;
  keepDrawerVisible?: boolean;
}

// Define the initial state using that type
const initialState: LightBoxState = {
  mobile: false,
  visible: false,
  isLoading: false,
  overlayVisible: true,
  allowBackgroundInteraction: false,
  contentVerticalAlign: 'center',
  contentHorizontalAlign: 'center',
  contentTopOffset: 0,
  contentBottomOffset: 0,
  contentLeftOffset: 0,
  keepDrawerVisible: false,
};

export const lightBoxSlice = createSlice({
  name: 'lightBox',
  initialState,
  reducers: {
    setVisibility: (state, action: PayloadAction<boolean>) => {
      state.visible = action.payload;
    },
    setContent: (state, action: PayloadAction<ReactElement>) => {
      state.content = action.payload;
    },
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setSecondVisibility: (state, action: PayloadAction<boolean>) => {
      state.secondVisible = action.payload;
    },
    setSecondContent: (state, action: PayloadAction<ReactElement>) => {
      state.secondContent = action.payload;
    },
    setMobile: (state, action: PayloadAction<boolean>) => {
      state.mobile = action.payload;
    },
    setOnClose: (state, action: PayloadAction<any>) => {
      state.onClose = action.payload;
    },
    setOnSecondClose: (state, action: PayloadAction<any>) => {
      state.onSecondClose = action.payload;
    },
    setNoDismiss: (state, action: PayloadAction<boolean>) => {
      state.noDismiss = action.payload;
    },
    setOverlayVisible: (state, action: PayloadAction<boolean>) => {
      state.overlayVisible = action.payload;
    },
    setAllowBackgroundInteraction: (state, action: PayloadAction<boolean>) => {
      state.allowBackgroundInteraction = action.payload;
    },
    setContentVerticalAlign: (state, action: PayloadAction<'center' | 'top' | 'bottom'>) => {
      state.contentVerticalAlign = action.payload;
    },
    setContentHorizontalAlign: (state, action: PayloadAction<'center' | 'left'>) => {
      state.contentHorizontalAlign = action.payload;
    },
    setContentTopOffset: (state, action: PayloadAction<number>) => {
      state.contentTopOffset = action.payload;
    },
    setContentBottomOffset: (state, action: PayloadAction<number>) => {
      state.contentBottomOffset = action.payload;
    },
    setContentLeftOffset: (state, action: PayloadAction<number>) => {
      state.contentLeftOffset = action.payload;
    },
    setKeepDrawerVisible: (state, action: PayloadAction<boolean>) => {
      state.keepDrawerVisible = action.payload;
    },
  },
});

export default lightBoxSlice.reducer;
export const lightBoxActions = lightBoxSlice.actions;
